import axios, { AxiosResponse } from 'axios';
import { AppThunk } from '../../app/store';
import { LIVECONTROLLER_CHECK_LIVE_ERR_MSG } from '../../utils/Message';
import { setError, setLiveControllerStatus } from '../../features/uiSlice';
import { setContract } from '../../features/userSlice';
import { UI_STATUS } from '../../utils/Const';
import { GetContract } from '../../types/API';

type CheckLiveCountParams = {
  cid: number;
  userApiParams: string;
  maxClient: number;
  contract: GetContract | null;
  setSimultaneousLiveCountDialog: React.Dispatch<React.SetStateAction<boolean>>;
  afterCheckedLiveCount: () => void;
};

/** ライブ同時開催数を確認し、上限超過しないかチェック */
const CheckLiveV3Count =
  (arg: CheckLiveCountParams): AppThunk =>
  async (dispatch) => {
    try {
      if (arg.contract === null) {
        // 契約会社情報取得API実行
        const responseGetContract: AxiosResponse<GetContract> =
          await axios.post(
            `${String(process.env.REACT_APP_BACKEND_API_ENDPOINT)}getContract`,
            {
              cid: arg.cid,
              userApiParams: arg.userApiParams,
            },
            {
              headers: {
                accept: 'application/json',
                'Content-type': 'application/json',
              },
            }
          );
        dispatch(setContract({ ...responseGetContract.data }));
        arg.contract = responseGetContract.data;
      }

      if (arg.contract.liveInfo.nowCnt + 1 > arg.contract.liveInfo.cntLive) {
        // 同時ライブ開催数についての警告orエラーダイアログを表示するフラグをONにする
        arg.setSimultaneousLiveCountDialog(true);
        return;
      }
      arg.afterCheckedLiveCount();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      // 異常終了
      dispatch(
        setError({
          msg: LIVECONTROLLER_CHECK_LIVE_ERR_MSG,
          detail: JSON.stringify(error.response?.data || error.message),
        })
      );
    } finally {
      dispatch(setLiveControllerStatus(UI_STATUS.COMPLETED));
    }
  };

export default CheckLiveV3Count;
